import { invalid, regex, required } from "common/forms"
import * as Yup from "yup"

const schema = Yup.object({
  licenceOrChassis: Yup.string()
    .required(required.licenceOrChassis)
    .matches(regex.licenceOrChassis, invalid.licenceOrChassis),
}).defined()

export const initialFormState: Yup.InferType<typeof schema> = {
  licenceOrChassis: "",
}

export default schema
